export const CONTACT_EMAIL = "Shayaspiritualpractice@gmail.com";
export const PAYPAL_URL = "https://www.paypal.com/qrcodes/p2pqrc/FCLEVKTTXLP36";

const FULL = [
  ["2026-04-01", "Pink Moon", "10:12 PM EDT", "Paschal Moon"], ["2026-05-01", "Flower Moon", "1:23 PM EDT"],
  ["2026-05-31", "Blue Moon", "4:45 AM EDT", "Blue Moon"], ["2026-06-29", "Strawberry Moon", "7:57 PM EDT"],
  ["2026-07-29", "Buck Moon", "10:36 AM EDT"], ["2026-08-28", "Sturgeon Moon", "12:18 AM EDT", "Lunar eclipse"],
  ["2026-09-26", "Harvest Moon", "12:49 PM EDT", "Harvest Moon"], ["2026-10-25", "Hunter's Moon", "11:12 PM EDT"],
  ["2026-11-24", "Beaver Moon", "9:53 AM EST", "Supermoon"], ["2026-12-23", "Cold Moon", "8:28 PM EST"],
];
const NEW = [
  ["2026-01-18", "Snow"], ["2026-02-17", "Worm"], ["2026-03-18", "Pink"], ["2026-04-17", "Flower"], ["2026-05-16", "Blue"],
  ["2026-06-14", "Strawberry"], ["2026-07-14", "Buck"], ["2026-08-12", "Sturgeon"], ["2026-09-10", "Harvest"],
  ["2026-10-10", "Beaver"], ["2026-11-09", "Beaver"], ["2026-12-08", "Cold"],
];

export const MOONS = [
  ...FULL.map(([date, name, time, tag]) => ({ date, phase: "full", name, time, tag })),
  ...NEW.map(([date, name]) => ({ date, phase: "new", name: `${name} New Moon`, time: "" })),
].sort((a, b) => a.date.localeCompare(b.date));

export const fmtMoonDate = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
export const moonLabel = (m) => `${m.phase === "full" ? "Full Moon" : "New Moon"} · ${m.name} · ${fmtMoonDate(m.date)}`;

export function upcomingMoons() {
  const d = new Date();
  const today = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  return MOONS.filter((m) => m.date >= today);
}

export const MEANINGS = [
  { lang: "Arabic", word: "Sha Ya", text: "Another name associated with the Prophet Isaiah." },
  { lang: "Persian", word: "Worthy", text: "Deserving — of love, abundance, healing and fulfillment." },
  { lang: "Hebrew", word: "Gift", text: "A physical manifestation of the Divine, from the Creator of all good things." },
];

export const SERVICES = [
  {
    id: "psychic-reading",
    testId: "service-card-psychic-readings",
    btnId: "book-psychic-reading-btn",
    no: "01",
    title: "Psychic Readings",
    lede: "The initial point of entry for many. A reading uncovers present circumstances, challenges, opportunities and spiritual guidance — booked online and held by video call or phone, whichever feels most comfortable for you. Sessions run in 15-minute steps, up to one hour.",
    points: ["Video call or phone", "Clairvoyance", "Clairsentience", "Clairaudience", "Channeling", "Mediumship"],
    image: "/img/tarot.jpg",
  },
  {
    id: "moon-ritual",
    testId: "service-card-moon-rituals",
    btnId: "book-moon-ritual-btn",
    no: "02",
    title: "Moon Rituals",
    lede: "Submit the desires you want to manifest. Diana works with celestial energies to bring them into being, performing your ritual during the new and full moon cycles.",
    points: ["Protection magic", "Manifestation", "Love rituals", "Prosperity & career", "New moon ceremonies", "Full moon ceremonies"],
    image: "/img/bayleaves.jpg",
  },
];

export const MODALITIES = [
  { k: "clairvoyance", name: "Clairvoyance", sub: "Clear seeing", text: "Visual impressions and insights regarding future possibilities and outcomes." },
  { k: "clairsentience", name: "Clairsentience", sub: "Clear feeling", text: "Perceiving emotional and energetic dynamics beneath the surface." },
  { k: "clairaudience", name: "Clairaudience", sub: "Clear hearing", text: "Guidance received through inner words, sounds and intuitive messages." },
  { k: "channeling", name: "Channeling", sub: "Higher guidance", text: "Direct communication with higher consciousness and spiritual guidance." },
  { k: "empathic", name: "Empathic Readings", sub: "Deep attunement", text: "Deep energetic attunement to emotional and energetic experiences." },
  { k: "mediumship", name: "Mediumship", sub: "Messages from beyond", text: "Facilitating communication and messages from loved ones who have passed." },
];

export const VALUES = [
  { name: "Divine Worthiness", text: "Every human being is inherently deserving of love, abundance, healing, and fulfillment." },
  { name: "Compassion", text: "Meeting every individual exactly where they are without judgment." },
  { name: "Integrity", text: "Spiritual guidance grounded in honesty, responsibility, and respect." },
  { name: "Empowerment", text: "Helping you discover your own connection to Spirit rather than creating dependency." },
  { name: "Inclusivity", text: "Welcoming, affirming spaces for people of all backgrounds, identities, cultures, and beliefs." },
  { name: "Service", text: "Every interaction is a sacred opportunity to serve." },
];

export const COMING = [
  { id: "meditation", name: "Meditation Services", text: "Individual guided sessions and group meditation circles for healing, peace, clarity and community.", tags: ["Individual", "Circles"] },
  { id: "education", name: "Spiritual Education", text: "Meditation, manifestation and sacred sexual energy classes for individuals, couples and groups.", tags: ["Classes", "Courses"] },
  { id: "business", name: "Spiritual Business Services", text: "Leadership guidance, workplace meditation, energy clearing and team wellness for organizations.", tags: ["Teams", "Workshops"] },
];

export const FAQS = [
  { q: "Are sessions in person or online?", a: "For now, everything is booked and held online, so you can take part from wherever you feel most at ease." },
  { q: "How do I book?", a: "Choose a service and share your details to send a booking request. You'll then see how to pay securely with PayPal, and receive a confirmation by email." },
  { q: "How much does a reading cost?", a: "Readings are booked in 15-minute steps up to one hour: 15 min $37.50, 30 min $75, 45 min $112.50, 1 hr $150 (USD). Each moon ritual is $77 USD." },
  { q: "Will my reading be by video or phone?", a: "Your choice. When you book a reading, pick a video meeting link or a phone call — whichever you feel most comfortable with." },
  { q: "What reading modalities do you work with?", a: "Clairvoyance, clairsentience, clairaudience, channeling, empathic readings and mediumship — guided by what comes through for you in session." },
  { q: "How does a moon ritual work?", a: "You submit the desires you want to manifest. Diana then works with celestial energies on your behalf, performing the ritual during the new and full moon cycles — for protection, manifestation, love and more." },
  { q: "What guides your practice?", a: "Every reading and ritual honors the law of love." },
  { q: "When will meditation and classes be available?", a: "They are rolling out over the next two years. Join the waitlist and you'll be the first to hear." },
];
